/**
 * 商户管理  奖励模板
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>奖励模板</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.templateName" placeholder="输入奖励模板名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="rewardName" align="center" label="模板名" width="100">
      </el-table-column>
      <el-table-column sortable prop="cycle" align="center" label="周期" width="100">
        <template slot-scope="scope">
          <div>{{formatCycle(scope.row.cycle)}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="checkField" align="center" label="校验字段" width="140">
        <template slot-scope="scope">
          <div>{{checkFieldFormat(scope.row.checkField)}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="checkRule" align="center"label="校验规则" width="360">
        <template slot-scope="scope">
          <el-tag type="success" v-for="(val,key) in scope.row.rule.slice(0,2)" :key="key"  style="margin-left: 5px">{{formatDescribeOnRow(scope.row,val)}}</el-tag>
          <el-tag type="success" v-if="scope.row.rule.length>2 " style="margin-left: 5px">...</el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="status" align="center" label="状态" width="100">
        <template slot-scope="scope">
          <div>{{statusFormat(scope.row.status)}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop=""  align="center"label="开始时间" width="100">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.startDate)}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop=""  align="center"label="结束时间" width="100">
        <template slot-scope="scope">
          <div>{{scope.row.endDate ? formatDate(scope.row.endDate) : '一直有效'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="140">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteRewardTemplate(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="9">
            <el-form-item label="奖励模板名" prop="templateName">
              <el-input size="small" v-model="editForm.rewardName" auto-complete="off" placeholder="请输入模板名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="周期" prop="cycle">
              <el-radio v-model="editForm.cycle" :label=1>周奖励</el-radio>
              <el-radio v-model="editForm.cycle" :label=2>月奖励</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="9">
            <el-form-item label="校验字段" prop="checkField">
              <el-select size="small" v-model="editForm.checkField" clearable placeholder="请选择校验字段">
                <el-option v-for="status in checkFieldEnum" :label="status.key" :value="status.value" :key="status.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="奖惩规则" prop="checkRule">
              <template>
                <el-radio-group v-model="editForm.checkRule">
                  <el-radio :label=1>奖励</el-radio>
                  <el-radio :label=2>惩罚</el-radio>
                  <el-radio :label=3>排行奖励</el-radio>
                  <el-radio :label=4>阶梯单价</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="9">
            <el-form-item label="模板状态" prop="status">
              <el-select size="small" v-model="editForm.status" clearable placeholder="请选择模板状态">
                <el-option v-for="status in statusEnum" :label="status.key" :value="status.value" :key="status.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="开始时间" prop="entryTime">
              <el-date-picker
                v-model="editForm.startDate"
                type="date"
                placeholder="请选择开始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="9"></el-col>
          <el-col :span="14">
            <el-form-item label="结束时间" prop="endDate">
              <!-- 含当天；不填表示一直有效。周期开始日晚于结束时间的批次不再生成、也不再计算 -->
              <el-date-picker
                v-model="editForm.endDate"
                type="date"
                clearable
                placeholder="不填表示一直有效">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="editForm.checkRule===4" type="flex" justify="start" align="middle">
          <div style="margin: 0 0 10px 120px; color: #909399; font-size: 12px;">
            阶梯单价：校验阈值填该档的起始数量，奖励金额填每个的金额；数量落在哪一档，全部数量都按该档单价算。<br>
            例：1→5、11→8、26→10，表示 10 人以下每人 5 元，11–25 人每人 8 元，26 人及以上每人 10 元。
          </div>
        </el-row>
        <el-row type="flex" justify="start" align="middle" v-for="(item, index) in editForm.rule" :key="index">
            <el-form-item label="校验阈值" prop="threshold">
              <el-input size="small" v-model="item.threshold" auto-complete="off" placeholder="请输入阈值">
              </el-input>
            </el-form-item>
            <el-form-item :label="editForm.checkRule===4 ? '每个金额' : '奖励金额'" prop="rewardAmount">
              <el-input size="small" v-model="item.rewardAmount" auto-complete="off" placeholder="请输入奖励金额">
              </el-input>
            </el-form-item>
            <el-button style="margin-bottom: auto;margin-left: 10px;" type="danger"  icon="el-icon-remove-outline" @click="delRule(index)" round></el-button>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="9">
            <el-form-item label="" prop="threshold">
              <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addRule()" round> </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" align="middle">
          <el-col :span="4" v-for="(item,index) in editForm.rule" :key="index">
          <el-tag type="success" size="medium" style="font-size: 15px;" >
              {{formatDescribe(item)}}
            </el-tag>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {formatPercentage} from '../../utils/util'
import Pagination from '../../components/Pagination'
import {delRewardTemplatePage, rewardTemplatePage, saveRewardTemplate} from "../../api/userMG";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '奖励模板',
      checkFieldEnum:[
        { key: '新卡总数', value: 'newCardCount'},
        { key: '新卡总额', value: 'newCardAmount'},
        { key: '充值总数', value: 'rechargeCardCount'},
        { key: '充值总额', value: 'rechargeCardAmount'},
        { key: '好评总数', value: 'favorableCommentAmount'},
        { key: '翻单总数', value: 'reorderCount'},
        { key: '指定总数', value: 'designatedCount'},
        { key: '免费补睫(普通)次数', value: 'refillNormalCount'},
        { key: '免费补睫(款式)次数', value: 'refillStyleCount'}
      ],
      statusEnum:[
        { key: '开启', value: 1},
        { key: '关闭', value: 0}
      ],
      editForm: {
        rewardTemplateId: null,
        rewardName: '',
        cycle: null,
        checkField:'',
        checkRule:1,
        rule:[{
          threshold:0,
          rewardAmount:0
        }],
        status:null,
        startDate:null,
        endDate:null,
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
      },
      formInline: {
        current: 1,
        size: 10,
        templateName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        current: 1,
        size: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getdata: function (parameter) {
        this.loading=true
        rewardTemplatePage(parameter)
        .then(res => {
          this.loading = false
          if (res.code!=='200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = res.data.pages
            this.pageparm.total = res.data.total
            this.loading=false
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('奖励模板加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parame) {
      this.formInline.current = parame.currentPage
      this.formInline.size = parame.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row !== undefined && row !== 'undefined') {
        this.title = '修改奖励模板'
        this.editForm.rewardTemplateId= row.rewardTemplateId
        this.editForm.rewardName= row.rewardName
        this.editForm.cycle= row.cycle
        this.editForm.checkField=row.checkField
        this.editForm.checkRule=row.checkRule
        this.editForm.threshold=row.threshold
        this.editForm.rewardAmount=row.rewardAmount
        this.editForm.status=row.status
        this.editForm.rule=row.rule
        this.editForm.startDate=row.startDate
        this.editForm.endDate=row.endDate || null
      } else {
          this.title = '添加奖励模板'
          this.editForm.rewardTemplateId= null
          this.editForm.rewardName= ''
          this.editForm.cycle= 1
          this.editForm.checkField=''
          this.editForm.checkRule=1
          this.editForm.threshold=null
          this.editForm.rewardAmount=null
          this.editForm.rule=[{
            threshold:0,
            rewardAmount:0
          }]
          this.editForm.status=null
          this.editForm.startDate=null
          this.editForm.endDate=null
      }
    },
    // 编辑、增加页面保存方法
    submitForm() {
      // 结束日期清空要显式告诉后端，否则后端会当成「没传」保留原值
      const payload = { ...this.editForm, clearEndDate: !this.editForm.endDate }
      saveRewardTemplate(payload).then(res => {
          if (res.code==='200') {
            this.$message({
              type: 'success',
              message: '奖励模板处理成功'
            })
            this.editFormVisible = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        }).catch(() => {
          this.$message.error('奖励模板处理失败，请稍后再试！')
        })
    },
    // 奖励模板
    deleteRewardTemplate(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          delRewardTemplatePage(row.rewardTemplateId)
            .then(res => {
              if (res.code==='200') {
                this.$message({
                  type: 'success',
                  message: '奖励模板已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            }).catch(() => {
              this.loading = false
              this.$message.error('奖励模板删除失败，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    formatCycle(itemValue){
      if(itemValue===null){
        return '';
      }
      if(itemValue===1){
        return '每周'
      }
      if(itemValue===2){
        return '每月'
      }
      return '';
    },
    formatDateStr(timestamp) {
      if(timestamp===null){
        return '';
      }
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}年${month}月${day}日`;
    },
    formatDescribe(obj){
      if(this.editForm.checkRule===1){
        return '满'+obj.threshold+"奖"+obj.rewardAmount
      }
      if(this.editForm.checkRule===2){
        return "少于"+obj.threshold+"罚"+obj.rewardAmount
      }
      if(this.editForm.checkRule===4){
        return obj.threshold+"起每个"+obj.rewardAmount
      }
      return "第"+obj.threshold+"名奖"+obj.rewardAmount
    },
    formatDescribeOnRow(row,rule){
      if(row.checkRule===1){
        return '满'+rule.threshold+"奖"+rule.rewardAmount
      }
      if(row.checkRule===2){
        return "少于"+rule.threshold+"罚"+rule.rewardAmount
      }
      if(row.checkRule===4){
        return rule.threshold+"起每个"+rule.rewardAmount
      }
      return "第"+rule.threshold+"名奖"+rule.rewardAmount
    },
    checkFieldFormat(itemValue){
      if(itemValue===null){
        return '';
      }
      for(let obj of this.checkFieldEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    formatDate(timestamp){
      if(timestamp===null){
        return '';
      }
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    statusFormat(itemValue){
      if(itemValue===null){
        return '';
      }
      for(let obj of this.statusEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    addRule(){
        let newRule={
          threshold:0,
          rewardAmount:0
        };
        this.editForm.rule.push(newRule);
    },
    delRule(obj){
        this.editForm.rule.splice(obj,1)

    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/mch/RewardTemplate.vue